import { routeConstants } from "services/keyConstants";

const baseUrl = `/${routeConstants.MAM_OF_PRODUCT}`;
const subUrl = `/${routeConstants.SAMLING_PLAN}`;

let fullUrl = baseUrl + subUrl;

export const GET_BY_ID = `${fullUrl}/`;
export const GET_DEFAULT_DATA = `${fullUrl}/get-default-data`;
export const GET_ALL = `${fullUrl}/get-all`;
export const DOWNLOAD = `${fullUrl}/download`;
export const UPDATE = `${fullUrl}/`;
export const DELETE = `${fullUrl}/`;
export const ADD = `${fullUrl}/`;
